import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class PointN extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.pointn',
        group: 'Spatial Accessors',
        title: 'ST Point N',
        description: `
      This component adds a new column
      with the point at the n-th position in the original LineString geography.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        },
        {
          name: 'index',
          type: WorkflowComponentParamType.Number,
          title: 'Point index',
          min: 0
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
        return dedent`SELECT SAFE.ST_POINTN(${params.geo}, ${params.index})
                AS ${params.geo}_point${params.index}, *
              FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40, ${params.geo}_point${
          params.index
        }) */
                SEDONA_ST_ASBINARY(SEDONA_ST_POINTN(SEDONA_ST_GEOMFROMWKB(${
                  params.geo
                }), ${params.index})) AS ${params.geo}_point${params.index}, *
              FROM ${connection.quoteName(params.source as string)}`
      default:
        return dedent`SELECT ST_POINTN(${params.geo}, ${params.index})
                AS ${params.geo}_point${params.index}, *
              FROM ${connection.quoteName(params.source as string)}`
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({
    columns,
    params,
    connection
  }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_point${params.index}`,
      type: connection.getGeoDataType()
    })
  }
}

export { PointN }
